import loadable from '@loadable/component';

export const BrokerSelfRequestFormWidgetAdapterLoadable = loadable(
  () =>
    import('./BrokerSelfRequestFormWidgetAdapter').catch(
      /* istanbul ignore next */ () => ({ BrokerSelfRequestFormWidgetAdapter: () => null }),
    ),
  {
    resolveComponent: ({ BrokerSelfRequestFormWidgetAdapter }) => BrokerSelfRequestFormWidgetAdapter,
    ssr: false,
  },
);
